import { mapGetters, mapState, mapActions } from 'vuex';
import closeButton from '@/components/generics/close-button/close-button.vue';
import purchaseJourney from '@/components/purchase/purchase-journey/purchase-journey.vue';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  props: {
    market: {},
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    closeJourneyAfterSuccess: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    closeButton,
    purchaseJourney,
  },
  methods: {
    ...mapActions('trade', ['setTradeOptions', 'clearOrderBook']),
    ...mapActions('popup', ['setCurrentPopup']),
    close() {
      this.setTradeOptions(null);
    },
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('trade', ['tradeOptions']),
  },
  created() {
    if (!this.isLoggedIn) {
      this.setCurrentPopup(MODALS.LOGIN);
    }
  },
  beforeDestroy() {
    this.clearOrderBook();
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/purchase-desktop/purchase-desktop.js